export const habaCommon = {
  pageHero: {
    sideTitle: 'On this page',
  },
  habaSearch: {
    placeholder: 'Search',
    showMore: 'Show more',
    home: 'Home',
    searchSuggestions: 'Suggestions',
    brandSuggestions: 'Brands',
    categorySuggestions: 'Categories',
    productSuggestions: 'Products',
    noSuggestions: 'No results.',
    noProductSuggestions: 'There are no product matches for your search.',
    viewAll: 'View all',
    contentPages: 'Magazine',
    servicesAndBenefits: 'Services & Benefits',
    faq: 'Frequently asked questions',
    more: 'More',
    searchHistory: 'Your search history',
    clearHistory: 'Clear',
    filterAndSort: 'Filter & Sort',
    filters: {
      age: 'Age',
      color: 'Color',
      brand: 'Brand',
      motives: 'Motif',
      more: 'More',
      price: 'Price',
      collections: 'Collection',
      campaignTags: 'Campaign',
      genders: 'Gender',
      size: 'Size',
      sizeSub: {
        appareal: 'Clothing sizes',
        belts: 'Belt sizes',
        brassieres: 'Bra sizes',
        caps: 'Hat sizes',
        gloves: 'Glove sizes',
        shoes: 'Shoe sizes',
        specials: 'Special sizes',
      },
      ageGroups: 'Age group',
      ageRange: 'Age',
      productFunctions: 'Function',
      productFeatures: 'Feature',
      materials: 'Material',
      sort: 'Sort',
      sortSub: {
        mostPopular: 'Most popular',
        new: 'New arrivals',
        priceAsc: 'Lowest price',
        priceDesc: 'Highest price',
        rating: 'Best rating',
        sale: 'Sale',
      },
      sortBy: 'Sort by',
      categories: 'More categories',
      reviews: 'Rating',
      show: 'Show',
      filter: 'Filter',
      resetAll: 'Reset all',
      showMore: '+ Show more',
      showLess: '- Show less',
      labels: {
        Babys: 'Baby (0 - 18 months)',
        Minis: 'Minis (1.5 - 5 years)',
        Kids: 'Kids (5 - 7 years)',
        Juniors: 'Juniors (from 8 years)',
        'keine Angabe': 'no specification',
        Junge: 'Boy',
        Mädchen: 'Girl',
        unisex: 'Unisex',
        Adults: 'Adults',
        männlich: 'male',
        weiblich: 'female',
        0: 'up to 1 year',
        1: 'from 1 year',
        2: 'from 2 years',
        3: 'from 3 years',
        4: 'from 4 years',
        5: 'from 5 years',
        6: 'from 6 years',
        7: 'from 7 years',
        8: 'from 8 years',
        9: 'from 9 years',
        10: 'from 10 years',
        11: 'from 11 years',
        12: 'from 12 years',
      },
      salesFilter: 'Special offers only',
      specialPrice: 'Special offers',
      personalization: 'Yes',
    },
    noResults: {
      showAllProducts: 'Show more',
      suggestions: 'Are you looking for this?',
      title: 'Hmmm...',
      messageFirstPart: 'We could not find any results for <b>"{{ query }}"</b>.',
      messageSecondPart:
        'Check your search again for typos or spelling errors - or try a different search term.',
    },
    recommendations: {
      similarProducts: 'Similar products',
      matchingProducts: 'Matching Products',
    },
  },
  habaNavigation: {
    showAll: 'Show all',
    more: 'More',
    back: 'back',
    allProducts: 'All products',
    topLinks: {
      contact: 'Contact',
    },
    showAllProducts: 'Show all products',
    shoppingCategories: 'Shopping categories',
    mainEditorialCategories: 'Tips and inspiration',
    metaNavigationCategories: 'Service & Contact',
    showMore: 'More categories & products',
    chooseLand: 'Choose your country',
  },
  habaHttpHandlers: {
    notFound: '404 Page not found',
    notAvailable: 'Page not available',
    code: {
      alreadyRedeemed: 'The code you entered has already been redeemed and cannot be used again.',
      maxApplied: 'A maximum of 3 gift cards can be redeemed with one order.',
      expired: 'The code you entered has already expired.',
      unknownException: 'The code entered is not valid.',
      giftcardDisabled:
        '<strong>We are sorry!</strong><br /> Our company is currently undergoing insolvency proceedings under self-administration. <br /><strong>If the gift card was purchased before 12.09.2023, the credit is part of the proceedings and unfortunately cannot be redeemed at the moment.</strong> <br />From presumably 01.12.2023 you can register and assert your claim in the insolvency table.',
      invalidCodeProvided:
        'This code is not valid. If you have further questions, please contact our customer service team.',
      giftcardCommunicationError:
        'The redemption of the code is temporarily not possible for technical reasons. Please try again later or contact our customer service team.',
      giftcardErrorS4NotAvailable:
        'Unfortunately, promotional codes cannot currently be redeemed for technical reasons. Please contact our customer service.',
      giftcardRedemptionNotAllowed: 'Vouchers cannot be redeemed with this payment method.',
      giftcardInvalidBusinessModel: 'The code cannot be redeemed in this webshop.',
      giftcardInvalidBrand: 'The gift card number cannot be redeemed in this webshop.',
      giftcardInvalidCurrency: 'The gift card number is not permitted for this currency.',
      giftcardAmount: 'The gift card has already been redeemed.',
      giftcardInvalid: 'Your gift card has unfortunately expired.',
      purchaseGiftcards: 'This payment method cannot be used for the purchase of gift vouchers',
      nothingLeftToPay: 'The amount has already been paid in full.',
      maximumQuantityReached: 'Requested quantities no longer available. Quantities changed.',
      maximumQuantityReachedProductPage: 'Maximum available quantity reached',
      noEffectOnCart:
        'Unfortunately, the product value of your order does not reach the minimum order value. Please increase your order value and enter the promotional code again.',
      noEffectOnCartWithoutCat:
        'The promotional code is only valid in connection with the purchase of products from the category {{additionalMessage}} or check the amount of the order value.',
      noEffectOnCartWithoutPerso:
        'The promotional code is only valid if your order contains a personalized item. If the product value of your order has not reached the minimum order value, please increase your order value and enter the promotional code again.',
    },
    registration: {
      successHaba:
        '<strong>Your HABA account is now active.</strong> Please sign in with your login credentials.',
      successHabaMobile:
        '<strong>Your HABA account is now active.</strong> <br /> Please sign in with your login credentials.',
      tokenExpired: 'Token expired',
      invalidToken: 'Invalid token',
      customerNotFound: 'Customer not found',
      userAlreadyExists: 'Oops, an error occurred. Please check your input.',
      userAlreadyExistsEnterOrResetPass:
        'A customer account already exists for this email address at HABA. Sign in <a href="{{loginUrl}}">here</a> or click on <a href="{{forgotPassUrl}}">forgot password</a> if you have forgotten your login details',
      genericError:
        'Unfortunately, that did not work. Please check that you are using the correct email address and password.',
    },
    featureNotAvailable:
      'This function is currently not available for technical reasons. Please contact our customer service.',
  },
  habaAuthentication: {
    success: 'Authentication successful',
  },
  habaFooter: {
    contact: {
      retour: {
        headline: 'Returns & Cancellation Form',
        description: 'Would you like to cancel an order or return an item?',
        button: 'Cancel order',
      },
    },
    info: {
      heading: 'Customer service',
      schedule: 'Monday - Friday 08-18 hours',
      telephone: '0800 - 9564956',
      email: 'service@wehfritz.com',
      contactForm: 'Contact form',
    },
    shop: {
      catalog: {
        headline: 'Our catalog',
        text1: 'Request catalog for free',
        text2: 'Browse online',
      },
      payment: {
        headline: 'Our payment methods',
      },
      secureShopping: {
        headline: 'Secure shopping',
        text1: 'Secure payment with SSL encryption',
      },
      newsletter: {
        headline: 'Newsletter',
        text1: 'To registration',
        text2: 'Stay informed about all offers, new products & craft tips',
      },
    },
    serviceLinksHeader: 'Services & Benefits',
    paymentMethodsHeader: 'Payment methods & secure shopping',
    helpfulLinksHeader: 'Helpful links',
    copyright:
      '© {{year}} - Habermaass GmbH & Co. KG and its brands are part of the Habermaass family of companies.',
    links: {
      service: {
        heading: 'Service',
        link1: 'On-site consultation',
        link2: 'Contact',
        link3: 'FAQ',
        link4: 'Leasing',
        link5: 'Return',
        link6: 'Certificates',
      },
      about: {
        heading: 'About us',
        link1: 'Events',
        link2: 'Company',
        link3: 'Jobs',
      },
    },
    meta: {
      link1: 'Contact',
      link2: 'Press',
      link3: 'Withdrawal instruction',
      link4: 'Withdrawal form',
      link5: 'Disposal notice',
      link6: 'Imprint',
      link7: 'Terms and conditions',
      link8: 'Privacy policy',
      link9: 'Cookie settings',
    },
    locale: {
      footerTitle: 'Country & language selection',
      modalTitle: 'Choose your country',
      country: 'Choose country',
      language: 'Language',
      message: 'Your cart will be emptied when you change your country.',
      submit: 'CONFIRM SELECTION',
    },
  },
  habaDelivery: {
    packageOnTheWay: 'Your package is on its way to you! Here you can track the shipment:',
  },
  footerNewsletter: {
    headline: 'Simply sign up for the newsletter and benefit permanently.',
    email: {
      label: 'Email address',
      error: 'Not a valid email address',
    },
    privacy: {
      label: 'I accept the <a>privacy policy</a>.',
      error: 'Please accept the privacy policy.',
    },
    submit: 'Subscribe to newsletter',
    submitError: 'Sorry, unfortunately that did not work.',
  },
  habaExternalMessages: {
    'payment.error.default':
      'A problem occurred while contacting the payment provider. Wait a few minutes and try again or choose a different payment method. If the problem persists, contact our customer service center.',
  },
  countdownBanner: {
    label: 'Time left:',
    days: 'Days',
    day: 'Day',
    hours: 'Hrs',
    minutes: 'Min',
    seconds: 'Sec',
    daysShort: 'D',
    hoursShort: 'H',
    minutesShort: 'M',
    secondsShort: 'S',
  },
};
